import { RestClient } from '@/api/rest-client'
import { User } from '@/api/model/user'
import { Comment } from '@/api/model/comment'

export class MentionClient extends RestClient<any> {
    async mention(comment: Comment, users: User[]): Promise<any> {
        return await super.axiosClient.post(`${this.basePath}/mention`, {
            comment: comment.resourceIdentifier,
            users: users.map(user => user.resourceIdentifier),
        })
    }
}
